// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2MhId","right":"styles_right__fFqWd"};